import Status from "../../../../components/Status";
import Button from "../../../../components/Button";
import detailStyles from "../../css/inventoryItemDetail.module.css";
import styles from "../css/expiredStock.module.css";
import { statusColor } from "./ColumnDefinitions";

export default function DispensaryModal({ selectedRow, roleId, onPullFromInventory }) {
  return (
    <div className={`${detailStyles.card} ${styles.viewMoreTheme}`}>
      <h2 style={{ marginTop: 0 }}>{selectedRow.drugName}</h2>

      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>SKU Number</label>
          <input type="text" defaultValue={selectedRow.sku ?? ""} />
        </div>
        <div className={detailStyles.field}>
          <label>Active Ingredient</label>
          <input type="text" defaultValue={selectedRow.drug?.activeingredient || ""} />
        </div>
      </div>

      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Dosage Form</label>
          <input type="text" defaultValue={selectedRow.drug?.dosageform || ""} />
        </div>
        <div className={detailStyles.field}>
          <label>Strength</label>
          <input type="text" defaultValue={selectedRow.drug?.strength || ""} />
        </div>
        <div className={detailStyles.field}>
          <label>Price</label>
          <input type="text" defaultValue={selectedRow.costprice ?? ""} />
        </div>
      </div>

      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Bin Number</label>
          <input type="text" defaultValue={selectedRow.drug?.binnumber || ""} />
        </div>
        <div className={detailStyles.field}>
          <label>Shelf</label>
          <input
            type="text"
            defaultValue={selectedRow.item?.shelvenumber || selectedRow.storage || ""}
          />
        </div>
        <div
          className={`${detailStyles.field} ${styles.expiryThemed}`}
          style={{"--expiry-color": statusColor(selectedRow.priority)}}
        >
          <label>Expiry Date</label>
          <input type="date" defaultValue={selectedRow.expiry || ""} disabled />
        </div>
      </div>

      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Quantity</label>
          <input type="text" defaultValue={selectedRow.qty} />
        </div>
        <div className={detailStyles.field}>
          <label>Priority Level</label>
          <div>
            <Status status={selectedRow.priority || "High"} variant="priority" />
          </div>
        </div>
        <div className={detailStyles.field}>
          <label>Date Received</label>
          <input type="date" defaultValue={selectedRow.lastReorder || ""} disabled />
        </div>
      </div>

      <div className={detailStyles.row}>
        <div className={detailStyles.field}>
          <label>Last Reorder</label>
          <input type="text" defaultValue={selectedRow.lastReorder || ""} />
        </div>
      </div>

      {roleId === 4 && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1.5rem",
          }}
        >
          <Button
            type="button"
            variant="secondary"
            onClick={() => onPullFromInventory?.(selectedRow.sku)}
          >
            Pull from inventory
          </Button>
        </div>
      )}
    </div>
  );
}
